import orderFlowReducer from '@core/utils/orderFlowReducer';
import { INIT_STORE } from '@shared/actionTypes';

import ModuleStateModel from './model';

const initialState = ModuleStateModel;

function checkoutModuleReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STORE:
      return ModuleStateModel.mergeDeep(state);
    default:
      return state;
  }
}

export default orderFlowReducer(checkoutModuleReducer, initialState);
